export enum EventActionType {
    ADD_EVENTS = "ADD_EVENTS",
    UPDATE_EVENT = "UPDATE_EVENT",
    EVENT_LOADING_ERROR = "EVENT_LOADING_ERROR",
}
